import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export interface LoadingDialogData {
  message?: string;
}

@Component({
  selector: 'app-loading-dialog',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  template: `
    <div class="flex flex-col items-center justify-center gap-4 p-6 min-w-[220px]">
      <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
      <p class="text-sm text-zinc-700 dark:text-zinc-200">{{ data.message || 'Please wait…' }}</p>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingDialogComponent {
  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: LoadingDialogData) {}
}
